import { Trans } from '@lingui/macro'
import { Box, Checkbox, CheckboxProps, FormControlLabel, Grid } from '@mui/material'
import { Field } from 'formik'
import { ErrorLabel } from '../forms/ErrorLabel'

export const CheckboxWithFormik = (
  props: CheckboxProps & CheckboxWithFormikProps
): JSX.Element => {
  const { name, controlLabel, style, labelPlacement } = props
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        const displayError = Boolean((meta.touched as boolean) && meta.error)
        const isChecked = Boolean(field.value)
        return (
          <Box>
            <FormControlLabel
              labelPlacement={labelPlacement}
              style={style}
              control={
                <Checkbox
                  checked={isChecked}
                  {...field}
                  {...props}
                  onChange={(_event, checked) => {
                    form.setFieldValue(name, !isChecked)
                    if (props.onChange != null) {
                      props.onChange(!isChecked)
                    }
                  }}
                />
              }
              label={controlLabel ?? ''}
            />
            {displayError && (
              <Grid item xs sx={{ ml: '20px' }}>
                <ErrorLabel label={<Trans>{meta.error}</Trans>} />
              </Grid>
            )}
          </Box>
        )
      }}
    </Field>
  )
}

interface CheckboxWithFormikProps {
  /**
   * This is an id of Formiks field that the TextField is connected to
   */
  name: string
  /**
   * Label rendered alongside the checkbox.
   */
  controlLabel?: React.ReactNode
  /**
   * Placement of the label rendered alongside the checkbox.
   */
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom' | undefined
}
